"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneServiceErrorCode = exports.OneServiceErrorCodeName = void 0;
const error_1 = require("../../error");
const utils_1 = require("../../utils");
var OneServiceErrorCodeName;
(function (OneServiceErrorCodeName) {
    OneServiceErrorCodeName["GENERIC_ERROR"] = "SYS001";
    OneServiceErrorCodeName["CAR_PARK_NOT_IN_PURVIEW_FILE"] = "CP001";
    // MYINFO
    // NOTE: referring to brv2 error codes
    OneServiceErrorCodeName["MYINFO_NOT_FOUND"] = "MY001";
})(OneServiceErrorCodeName || (exports.OneServiceErrorCodeName = OneServiceErrorCodeName = {}));
(function (OneServiceErrorCodeName) {
    OneServiceErrorCodeName.fn = {
        values: utils_1.EnumUtils.valuesFunc(OneServiceErrorCodeName),
        toEnumKey: utils_1.EnumUtils.toEnumKeyFunc(OneServiceErrorCodeName),
        toEnumValue: utils_1.EnumUtils.toEnumValueFunc(OneServiceErrorCodeName),
    };
})(OneServiceErrorCodeName || (exports.OneServiceErrorCodeName = OneServiceErrorCodeName = {}));
var OneServiceErrorCode;
(function (OneServiceErrorCode) {
    OneServiceErrorCode.GENERIC_ERROR = Object.freeze(new error_1.ErrorCodeV2({
        code: OneServiceErrorCodeName.GENERIC_ERROR,
        httpStatusCode: 500,
        message: "An error occurred while processing your request",
    }));
    OneServiceErrorCode.CAR_PARK_NOT_IN_PURVIEW_FILE = Object.freeze(new error_1.ErrorCodeV2({
        code: OneServiceErrorCodeName.CAR_PARK_NOT_IN_PURVIEW_FILE,
        httpStatusCode: 500,
        message: "An error occurred while processing your request",
    }));
    OneServiceErrorCode.MYINFO_NOT_FOUND = Object.freeze(new error_1.ErrorCodeV2({
        code: OneServiceErrorCodeName.MYINFO_NOT_FOUND,
        httpStatusCode: 500,
        message: "An error occurred while fetching myinfo data",
    }));
})(OneServiceErrorCode || (exports.OneServiceErrorCode = OneServiceErrorCode = {}));
//# sourceMappingURL=error.js.map